// extracted by mini-css-extract-plugin
export var wrapper = "testimonial-module--wrapper--130kZ";
export var title = "testimonial-module--title--1z181";
export var containerMain = "testimonial-module--containerMain--32mUK";
export var profileImg = "testimonial-module--profileImg--3qJwz";
export var testimonialText = "testimonial-module--testimonialText--1H_Dg";
export var clientName = "testimonial-module--clientName--2xeop";
export var clientAbout = "testimonial-module--clientAbout--Dw4KK";
export var jobtitle = "testimonial-module--jobtitle--y7mCt";
export var link = "testimonial-module--link--38fzT";